import React, { useEffect, useState } from "react";
import { SongCard } from "./SongCard";
import { TrackData } from "../types/Types";
import { RecentlyAddedService } from "../services/RecentlyAddedService";
import "../App.css";
import "../styles/HorizontalTrackFeeds.css";

export const RecentlyAdded = () => {
  const [tracks, setTracks] = useState<TrackData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTracks = async () => {
      const data = await RecentlyAddedService.getRecentlyAddedTracks();
      setTracks(data);
      setLoading(false);
    };

    fetchTracks();
  }, []);

  if (loading) {
    return <div className="recently-added-section text-white">Loading...</div>;
  }

  return (
    <section className="recently-added-section">
      <div className="recently-added-feed-header-container">
        <h2 className="scrollable-feed-header">Recently Added</h2>
      </div>

      <div className="song-card-scroll-container">
        {tracks.map((track) => (
          <SongCard key={track.id} track={track} />
        ))}
      </div>
    </section>
  );
};
